// extracted by mini-css-extract-plugin
export default {"aboutSection":"About_aboutSection__WHwvQ","title":"About_title__+6bic","description":"About_description__dltyT","featureCard":"About_featureCard__Y2t0j"};